import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {TenantTeamRoleContainerModel} from '../../../../../models/aggregates/role';


@Injectable({
  providedIn: 'root'
})
export class TenantTeamRoleService extends BaseApiTemplateService<TenantTeamRoleContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/team-role-links/team-to-role';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/team-role-links/team-to-role';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/team-role-links/team-to-role';
    this.httpClient = http;
  }
  
}